import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useMutation } from '@apollo/client';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Toggle from '@mui/material/Switch';
// import tracker, { TrackerFragments } from 'lib/tracker';
import {
  ADD_USER_INTREST,
  DELETE_USER_INTREST,
} from '../../../schema/apolloMutations/profileMutations';
import { GET_PROFILE_DETAIL } from '../../../schema/apolloQueries/profileQueries';

const useStyles = makeStyles(theme => ({
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItem: {
    color: theme.palette.text.primary,
  },
}));

const ProfileInterests = ({ viewer, personId }) => {
  const [addUserIntrests] = useMutation(ADD_USER_INTREST, {
    refetchQueries: [GET_PROFILE_DETAIL],
  });
  const [deleteUserIntrests] = useMutation(DELETE_USER_INTREST, {
    refetchQueries: [GET_PROFILE_DETAIL],
  });
  const styles = useStyles();
  const edges = [...viewer];

  const handleToggle = (categoryId, isInterested) => {
    if (!isInterested) {
      addUserIntrests({ variables: { interestId: categoryId, personId } })
        .then(res => {
          if (res.data.interestedInEventCategory) {
            // eslint-disable-next-line no-console
            console.log('success');
          }
        })
        .catch(() => {
          // console.log("error", e);
        });
    } else {
      deleteUserIntrests({ variables: { interestId: categoryId, personId } })
        .then(res => {
          if (res.data.notInterestedInEventCategory) {
            // eslint-disable-next-line no-console
            console.log('success');
          }
        })
        .catch(() => {
          // console.log("error", e);
        });
    }
  };
  return (
    <List className={styles.list}>
      {edges.map(
        useCallback(
          (category, i) => (
            <Fragment key={category.categoryId}>
              <ListItem className={styles.listItem}>
                <ListItemText primary={category.name} />
                <ListItemSecondaryAction>
                  <Toggle
                    onChange={() => {
                      handleToggle(
                        category.categoryId,
                        category.isInterested,
                        i,
                      );

                      //   relay.commitUpdate(
                      //   new ToggleCategoryInterest({ category }),
                      //   {
                      //     onSuccess: () => {
                      //       tracker.trackGoogleAnalyticsEvent(
                      //         'User',
                      //         `${category.interested
                      //           ? 'Disable'
                      //           : 'Enable'} interest`,
                      //         { viewer },
                      //       );
                      //     },
                      //     onFailure: transaction => {
                      //       const { message } = extractTransactionError(transaction);
                      //       tracker.trackGoogleAnalyticsException(
                      //         message,
                      //         { viewer },
                      //       );
                      //     },
                      //   },
                      // )
                    }}
                    checked={category.isInterested}
                  />
                </ListItemSecondaryAction>
              </ListItem>
              {i + 1 < edges.length && <Divider />}
            </Fragment>
          ),
          [
            edges.length,
            // relay,
            viewer,
            styles,
          ],
        ),
      )}
    </List>
  );
};

ProfileInterests.propTypes = {
  personId: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  setIntrests: PropTypes.object.isRequired,
};

export default ProfileInterests;
